import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/store-locator';
import {
    actions as checkoutActions,
    selectors as checkoutSelectors,
} from '@elab/core/store/checkout';

class PickStore extends SimpleLitElement {
    static get properties() {
        return {
            tableHeadCity: { type: String, attribute: 'table-head-city' },
            tableHeadDate: { type: String, attribute: 'table-head-date' },
            tableHeadAddress: { type: String, attribute: 'table-head-address' },
            tableHeadHours: { type: String, attribute: 'table-head-hours' },
            openingHours: { type: String, attribute: 'opening-hours' },
            btnChooseStore: { type: String, attribute: 'btn-choose-store' },
            btnSelectedStore: { type: String, attribute: 'btn-selected-store' },
            selectedStore: { type: String, attribute: false },
        };
    }

    constructor() {
        super();
        this.selectedStore = false;
    }

    get stores() {
        return this.__stores;
    }

    set stores(newValue) {
        const oldValue = this.__stores;
        this.__stores = newValue;

        this.selectStore();

        this.requestUpdate('hasError', oldValue);
    }

    selectStore() {
        let selectedStoreName = false;

        if (this.__stores[0] && this.__stores[0].name) {
            selectedStoreName = this.__stores[0].name;
        }

        if (this.selectedStore !== selectedStoreName) {
            this.dispatchEvent(new CustomEvent('select-store', { detail: selectedStoreName }));
        }
    }

    render() {
        return html`
            <div class="checkout-pickup-store-section-full__another-store-table">
                ${this.stores.length > 0
                    ? html`
                          <div class="store-pickup__table-heading display--desktop-only">
                              <div class="store-info store-info--desktop-heading">
                                  <div
                                      class="store-info__item store-info__item--bold store-info__item--city"
                                  >
                                      ${this.tableHeadCity}
                                  </div>
                                  <div
                                      class="store-info__item store-info__item--bold store-info__item--date"
                                  >
                                      ${this.tableHeadDate}
                                  </div>
                                  <div
                                      class="store-info__item store-info__item--bold store-info__item--address"
                                  >
                                      ${this.tableHeadAddress}
                                  </div>
                                  <div
                                      class="store-info__item store-info__item--bold store-info__item--hours"
                                  >
                                      ${this.tableHeadHours}
                                  </div>
                              </div>
                          </div>

                          <!--RESULTS WRAPPER-->
                          <div class="store-info__content-wrapper">
                              ${this.stores.map(
                                  (_, i) => html`
                                      <e2-pick-store-card
                                          store-index="${i}"
                                          mobile-town="${this.tableHeadCity}"
                                          collection-point="${this.tableHeadDate}"
                                          opening-hours="${this.openingHours}"
                                          choose-this-store="${this.btnChooseStore}"
                                          selected-store="${this.btnSelectedStore}"
                                      ></e2-pick-store-card>
                                  `,
                              )}
                          </div>
                      `
                    : null}
            </div>
        `;
    }
}

const mapStateToProps = state => ({
    stores: selectors.getStores(state),
    selectedStore: checkoutSelectors.getSelectedStore(state),
});

const mapDispatchProps = dispatch => ({
    'select-store': ({ detail }) => dispatch(checkoutActions.selectStore(detail)),
});

export default () =>
    customElements.define('e2-pick-store', connect(mapStateToProps, mapDispatchProps)(PickStore));
